import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { NzSkeletonComponent } from "ng-zorro-antd/skeleton";
import { UiSkeletonAvatar, UiSkeletonCustomMeasurements, UiSkeletonParagraph, UiSkeletonSectionHeight, UiSkeletonTitle } from "@webapp/ui/skeleton/skeleton.type";

@Component({
  selector: "ui-skeleton",
  exportAs: "uiSkeleton",
  templateUrl: "skeleton.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: "ant-skeleton",
    "[class.ant-skeleton-with-avatar]": "!!nzAvatar",
    "[class.ant-skeleton-active]": "nzActive",
    "[class.ant-skeleton-round]": "nzRound",
  },
})
export class UiSkeletonComponent extends NzSkeletonComponent {
  @Input("uiActive") public nzActive = false;
  @Input("uiLoading") public nzLoading = true;
  @Input("uiRound") public nzRound = false;
  @Input("uiTitle") public nzTitle: UiSkeletonTitle | boolean = true;
  @Input("uiAvatar") public nzAvatar: UiSkeletonAvatar | boolean = false;
  @Input("uiParagraph") public nzParagraph: UiSkeletonParagraph | boolean = true;
  // The view uses internal (private) models of the paragraph and title, which are being created in the parent nz class
  // If we want to give each paragraph row a different height, we need to configure it in the same manner as the width configuration,
  // transfer their logic to our code and extend it
  @Input() public uiSectionHeight: UiSkeletonSectionHeight = { title: "h-md", paragraph: "h-sm" };
  @Input() public uiCustom = false;
  @Input() public uiCustomMeasurements: UiSkeletonCustomMeasurements;

  constructor(cdr: ChangeDetectorRef) {
    super(cdr);
  }
}
